/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
/**
  * Helper to normalize a theme variable (defined in ems) against the applied
  * fontSize (also defined in ems), so that the resulting value renders correctly
  */
export default function getNormalizedValue(value: string, base: string) {
  return `${parseFloat(value) / parseFloat(base)}em`;
}



// WEBPACK FOOTER //
// ./src/utils/getNormalizedValue.js